import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_PharmacyHistory = () => {
  const [data, setData] = useState(null);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    const apiPath = getAPIPath(currentDomain)?.pharmacyHistory;
    fetchData(apiPath, setData);
  }, [currentDomain]);

  // Function to render rich text content
  const renderRichText = (content) => {
    if (!content || !Array.isArray(content)) return null;

    return content.map((block, blockIndex) => {
      if (block.type === "paragraph") {
        return (
          <p key={blockIndex} className="mb-3 text-justify">
            {block.children?.map((child, childIndex) => {
              if (child.type === "text") {
                let text = child.text;
                
                // Apply formatting
                if (child.bold) {
                  text = <strong key={childIndex}>{text}</strong>;
                }
                if (child.italic) {
                  text = <em key={childIndex}>{text}</em>;
                }
                if (child.underline) {
                  text = <u key={childIndex}>{text}</u>;
                }
                
                return text;
              }
              return child.text || "";
            })}
          </p>
        );
      } else if (block.type === "list") {
        const ListTag = block.format === "ordered" ? "ol" : "ul";
        
        return (
          <ListTag key={blockIndex} className="history-list mb-4">
            {block.children?.map((listItem, itemIndex) => {
              if (listItem.type === "list-item") {
                return (
                  <li key={itemIndex} className="history-item mb-2">
                    {listItem.children?.map((child, childIndex) => {
                      if (child.type === "text") {
                        let text = child.text;
                        
                        // Apply formatting
                        if (child.bold) {
                          text = <strong key={childIndex}>{text}</strong>;
                        }
                        if (child.italic) {
                          text = <em key={childIndex}>{text}</em>;
                        }
                        if (child.underline) {
                          text = <u key={childIndex}>{text}</u>;
                        }
                        
                        return text;
                      }
                      return child.text || "";
                    })}
                  </li>
                );
              }
              return null;
            })}
          </ListTag>
        );
      } else if (block.type === "heading") {
        const HeadingTag = `h${block.level || 3}`;
        return (
          <HeadingTag key={blockIndex} className="mb-3">
            {block.children?.map((child, childIndex) => {
              if (child.type === "text") {
                return child.text;
              }
              return "";
            })}
          </HeadingTag>
        );
      }
      
      return null;
    });
  };

  const historyData = data?.data?.attributes;

  return (
    <React.Fragment>
      <Helmet>
        <title>Pharmacy History & Evolution | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="History and Evolution of Pharmacy at Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Pharmacy History, Evolution, OTPRI, Oil Technological, Pharmaceutical Research Institute, JNTUA, Dhanvantri"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .history-list {
                        padding-left: 20px;
                    }
                    
                    .history-item {
                        margin-bottom: 10px;
                        line-height: 1.6;
                    }

                    .section-container {
                        background: #fff;
                        padding: 35px;
                        border-radius: 12px;
                        box-shadow: 0 4px 20px rgba(0,0,0,0.08);
                        margin-bottom: 30px;
                        border-left: 5px solid #007bff;
                        transition: all 0.3s ease;
                        position: relative;
                        overflow: hidden;
                    }

                    .section-container::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 3px;
                        background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);
                    }

                    .section-container:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 8px 30px rgba(0,123,255,0.15);
                    }

                    .section-title {
                        color: #007bff;
                        font-weight: 700;
                        margin-bottom: 25px;
                        padding-bottom: 15px;
                        border-bottom: 2px solid #e9ecef;
                        position: relative;
                        font-size: calc(${fontSize}px + 8px);
                    }

                    .section-title::after {
                        content: '';
                        position: absolute;
                        bottom: -2px;
                        left: 0;
                        width: 60px;
                        height: 2px;
                        background: linear-gradient(90deg, #007bff 0%, #0056b3 100%);
                    }

                    .section-content {
                        line-height: 1.8;
                        color: #444;
                    }

                    .section-content p {
                        text-align: justify;
                        margin-bottom: 20px;
                        font-size: calc(${fontSize}px + 1px);
                        line-height: 1.7;
                    }

                    .main-title {
                        color: #e6087c;
                        margin-bottom: 40px;
                        font-weight: 700;
                        position: relative;
                    }

                    .timeline-section {
                        position: relative;
                    }

                    .timeline-section::before {
                        content: '';
                        position: absolute;
                        left: 10px;
                        top: 0;
                        bottom: 0;
                        width: 3px;
                        background: linear-gradient(180deg, #007bff 0%, #0056b3 100%);
                        border-radius: 2px;
                    }

                    .timeline-marker {
                        position: absolute;
                        left: 2px;
                        top: 20px;
                        width: 18px;
                        height: 18px;
                        background: #007bff;
                        border-radius: 50%;
                        border: 3px solid #fff;
                        box-shadow: 0 2px 10px rgba(0,123,255,0.3);
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Pharmacy History & Evolution"
          pageName="Pharmacy History & Evolution"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="main-title">
                      {historyData?.title || "Pharmacy History & Evolution of Pharmacy"}
                    </h3>
                    
                    <div className="timeline-section">
                      {historyData?.sections?.map((section, index) => (
                        <div key={section.id || index} className="section-container">
                          <div className="timeline-marker"></div>
                          {section.title && (
                            <h4 className="section-title">{section.title}</h4>
                          )}
                          <div className="section-content">
                            {renderRichText(section.content)}
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {(!historyData?.sections || historyData?.sections?.length === 0) && (
                      <div className="section-container">
                        <div className="text-center" style={{ padding: "60px 20px", color: "#666" }}>
                          <i className="fas fa-history" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                          <br />
                          <h5 style={{ color: "#999", fontWeight: "normal" }}>No history information available at the moment.</h5>
                          <p style={{ color: "#bbb", fontSize: "14px" }}>Please check back later for updates.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_PharmacyHistory;